import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";

export const BoatEngine = ({ horsepower }: { horsepower: string | number | undefined }) => {
  const { i18n } = useLingui();
  if (horsepower == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.boat.motor",
    message: "Motor size",
    comment: "Field for 'engine effect' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.keyInfo.boat.motor.size",
    message: "{motorSize} hp",
    comment: "Engine effect postfix in ad specification",
    values: {
      motorSize: horsepower,
    },
  });
  return <FieldValuePair field={field} value={value} />;
};
